// extracted by mini-css-extract-plugin
export default {"overlay":"styles_overlay__AN+xZ","container":"styles_container__bzWc2","spin":"styles_spin__4-Etu","containerContract":"styles_containerContract__yEzSs"};